function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useEffect } from 'react';
import createFocusTrap from 'focus-trap';
var DEFAULTS = {
  activate: false,
  clickOutsideDeactivates: false,
  escapeDeactivates: false
};
export default function useFocusTrap(ref, options) {
  var activate;
  var rest;
  if (typeof options === 'boolean') {
    activate = options;
  } else {
    var _Object$assign = Object.assign({}, DEFAULTS, options);
    activate = _Object$assign.activate;
    rest = _objectWithoutProperties(_Object$assign, ["activate"]);
  }
  useEffect(function () {
    var el = ref.current;
    var focusTrap;
    if (el) {
      focusTrap = createFocusTrap(el, rest);
      if (activate) {
        focusTrap.activate();
      } else {
        focusTrap.deactivate();
      }
    }
    return function () {
      if (focusTrap) {
        focusTrap.deactivate();
      }
    };
  }, [activate, ref]);
}